import { inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CanActivateFn } from '@angular/router';

import { ISnackBarData, SnackBarComponent } from '@lyra/app/shared/components/snack-bar/snack-bar.component';
import { AuthService } from '@mark/common-lib/services';
import { Store } from '@ngrx/store';
import { map, of, switchMap, tap } from 'rxjs';

import { SIGN_UP_SUCCESS } from '../store/actions/setting.actions';
import { SettingSelectService } from '../store/selectors';
import { IAppState } from '../store/states/app.state';

export const orderAuthGuard: CanActivateFn = () => {
  const _settingSelect = inject(SettingSelectService);
  const _authService = inject(AuthService);
  const _snackBar = inject(MatSnackBar);
  const _store$ = inject(Store<IAppState>);

  return _settingSelect.validToken().pipe(
    switchMap((x) => {
      if (x) {
        return of(x);
      }
      return _authService.login({ lang: 'en' }).pipe(
        tap(({ status, error }) => {
          if (status === 'error') {
            _snackBar.openFromComponent(SnackBarComponent, {
              data: {
                text: error ? error : 'Oops! Something went wrong. Please try again.',
                closeButton: true,
                icon: { name: 'info' },
                action: 'error',
              } as ISnackBarData,
              duration: 5000,
              verticalPosition: 'top',
              horizontalPosition: 'center',
              panelClass: ['mark-snackbar', 'error'],
            });
          }
        }),
        map(({ status }) => status === 'success'),
        tap((valid) => {
          _store$.dispatch(SIGN_UP_SUCCESS({ valid }));
        }),
      );
    }),
  );
};
